import { useState } from 'react';
import Description from './Description';


const DescriptionWrapper = (props) => {
    const [yPos, setYPos] = useState(99999);
    const [xPos, setXPos] = useState(0);
    function isOver(e){
        setYPos(e.clientY + 3 + props.size.height > window.innerHeight ? window.innerHeight - props.size.height : e.clientY + 3);
        setXPos(e.clientX + 47 + props.size.width > window.innerWidth ? window.innerWidth - props.size.width - 17 : e.clientX + 30);
    }
    return(
            <div className={`descriptionWrapper`} onMouseMove={isOver} style={props.style}>
                {props.children}
                <Description description={props.description} x={xPos} y={yPos} color={props.color}/>
            </div>
    );
}
export default DescriptionWrapper;